import { TooltipPosition, EpicIcons } from "@constellation-academy/epic-ui";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import type { EditDiscountActionButtonProps } from "./edit-discount-actions-button.types";
import { Button } from "../../../../components/button";
import { Paths } from "../../../../routes/paths";

export const EditDiscountActionButton = ({ id, isArchivePage }: EditDiscountActionButtonProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	const handleOnClick = () => {
		navigate(
			isArchivePage
				? Paths.archivedDiscountActions.withId(id).edit.path
				: Paths.activeDiscountActions.withId(id).edit.path,
		);
	};

	return (
		<Button
			icon={EpicIcons.PENCIL}
			tooltip={t("discounts.editDiscount")}
			position={TooltipPosition.Left}
			onClick={handleOnClick}
		/>
	);
};
